import classes from '@nerdwallet/base-styles/classes';

export default {
  tiles: [
    {
      company: 'iHeart Impact',
      height: '115px',
      width: '164px',
      naturalHeight: 154,
      naturalWidth: 210,
      isAwardLogo: true,
      smallSizeTile: true,
      customTileStyle: classes(
        'margin-vertical-4',
        'padding-right-2',
        'padding-right-3--wide'
      ),
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/iHeartIMPACT_logo_primary-dark%203-v2.png',
    },
    {
      company: 'Match Group',
      height: '90px',
      width: '208px',
      naturalHeight: 90,
      naturalWidth: 300,
      midSizeTile: true,
      isAwardLogo: true,
      customTileStyle: classes(
        'margin-vertical-4',
        'padding-left-2',
        'padding-left-3--wide'
      ),
      image:
        'https://www.nerdwallet.com/cdn/company/2021/icons/MG__Logo_Horizontal_LightBackground-(2)+2.png',
    },
  ],
};
